module.exports = __webpack_public_path__ + "static/img/zeta_cr_template_07.74e8cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zeta_cr_template_07.png
// module id = Xd9j
// module chunks = 1